import { ref } from "vue";
import { useStore } from "@/store";
const store = useStore();
const activeRowModal: any = ref({ data: null });
import { GeneralActionTypes } from "@/store/modules/general/action-types";

function getFolderNameById(value: number): string | undefined {
    const folderMaps = store.state.general.folderMaps as { label: string; value: number }[];
    const folder = folderMaps.find((item: any) => item.value === value);
    return folder?.label;
}

function getAccessControlById(value: number): string | undefined {
    const accessControlOptions = store.state.general.enums['AccessControl'] || []
    const folder = accessControlOptions.find((item: any) => item.value === value);
    return folder?.label;
}
const data = {
    filter: {
        title: "processfilter",
        pageName: "processfilter",
        genre: "processPageFilter",
        ignoreSaveFilter: true,
        noDateSelect: true,
        hideFilter: false,
        //quickSearch: "fullTextSearch",
        filters: [
        ],
    },
    header: {
        navigation: [

        ],
        buttonPosition: "pr-4 justify-content-between",
        buttons: [

        ],
    },
    component: {
        type: "ag-table",
        options: {
            columns: [
                {
                    label: "PATH",
                    field: "fileName",
                    sortable: true,
                    jsSort: true,
                    display: (row: any) => {
                        const path = row.fileName ?? "";
                        const hasFolderMap = row.folderMapId !== null && row.folderMapId !== undefined;
                        const hasHash = row.aecConditionHash !== null || row.moduleConditionHash !== null;
                        const folderMap = hasFolderMap ? (getFolderNameById(row.folderMapId) ?? "") : "";
                        const fullPath = !hasFolderMap && row.isFolderMapIdAny
                            ? `*\\${path}`
                            : (folderMap && path
                                ? `${folderMap}\\${path}`
                                : `${folderMap}${path}`);

                        let html = "<div class='d-flex flex-column align-items-start'>";
                        const nameToShow = (row.displayName && String(row.displayName).trim().length > 0)
                            ? String(row.displayName)
                            : folderMap;
                        html += "<span style='color: #01172F; font-weight: bold;'>" + nameToShow + "</span>"
                        if(hasHash){
                            html += "<div class='d-flex align-items-center' style='margin-top:10px'><span style='color: #01172F; font-weight: 400;'>" + fullPath + "</span><i class='ag-icon ag-icon_hash_file' style='font-size:0.8em !important; margin-left: 5px;'></i></div>";
                        }else{
                            html += "<span style='color: #01172F; font-weight: 400;'>" + fullPath + "</span>"
                        }
                        
                        if (row.enabled === false) {
                            html += "<div class='d-flex align-items-center' style='margin-top:10px'><i class='ag-icon ag-icon_warning_filled' style='font-size:0.8em !important;'></i><span style='font-size:0.7em; color:#636363;'>This rule is disabled and will not be published</span></div>";
                        }
                        html += "</div>";
                        return html;
                    },
                    width: "35%",
                },
                {
                    label: "ACCESS CONTROL",
                    field: "accessControl",
                    display: (row: any) => {
                        const accessControl =row.accessControl ? getAccessControlById(row.accessControl) : "";
                        return `<span style='color: #01172F;'>${accessControl}</span>`;
                    },
                    sortable: true,
                    jsSort: true,
                    width: "25%",
                },
                {
                    label: "ADDITIONAL CONTROLS",
                    field: "applicationExecutionControl",
                    display: (row: any) => {
                        const additionalControls = [];
                        if (row.applicationExecutionControl) {
                            additionalControls.push("Application Execution Control")
                        }
                        if (row.moduleControl) {
                            additionalControls.push("Module Control")
                        }
                        return (
                            `<ul style="padding-left: 1.25rem; margin: 0; list-style-type: none; color: #01172F;">
                                ${additionalControls.map((item) => `<li>${item}</li>`).join("")}</ul>`
                        );
                    },
                    sortable: false,
                    width: "25%",
                },
                {
                    label: "ACTION",
                    field: "commands",
                    components: [
                        {
                            component: "appGroupTableEditComponent",
                        },
                        {
                            component: "copyAction",
                            class: "mr-2 ml-2",
                        },
                        {
                            component: "appGroupDeleteComponent",
                        },
                    ],
                    width: "120px",
                },
            ],
            rows: [],
            total: 0,
            sortable: {
                order: "",
                sort: "asc",
            },
            page: 0,
            pageSize: 0,
            showPagination: false,
            isLoading: true,
            dateFilter: false,
            zebra: true,
            separateBorders: true,
            editOnRowClick: true,
            fetchTable: (options: any) => {
                store.dispatch(GeneralActionTypes.GET_APPGROUP_PROCESS, {
                    options: options,
                    filters: {}
                });
            }
        }
    },

};

export default data;
